/**
 * KO translations — generated by scripts/build-locale-translations.mjs.
 * Keys marked '// @en' still return the English string; run the
 * generator after a translation pass to update this file.
 */
export const ko = {
  "nav.home": "홈",
  "nav.about": "회사 소개",
  "nav.products": "제품",
  "nav.capabilities": "기술력",
  "nav.quality": "품질 및 규제",
  "nav.news": "뉴스",
  "nav.contact": "문의",
  "header.phone": "전화",
  "header.email": "이메일",
  "header.rfq_cart": "장바구니",
  "button.request_quote": "견적 요청",
  "search.placeholder": "CAS 번호 또는 제품명으로 검색",
  "language.change": "언어 변경",
  "hero.badge": "ISO 9001:2015 인증",
  "hero.title.leading": "선도적인",
  "hero.title.pharmaceutical": "제약",
  "hero.title.innovation": "혁신",
  "hero.description": "Longshine Boi-Tech은 인도의 ISO 인증 시설에서 프리미엄 API, 제약 중간체, 동물용 화합물을 글로벌 시장에 공급합니다.",
  "hero.button.explore": "제품 살펴보기",
  "hero.button.quote": "견적 요청",
  "hero.stats.countries": "거래국",
  "hero.stats.products": "취급 제품",
  "hero.stats.years": "연혁",
  "categories.title": "프리미엄 제약 솔루션",
  "categories.subtitle": "Discover our comprehensive range of APIs, intermediates, and specialized compounds manufactured to the highest international standards.", // @en
  "categories.search.placeholder": "Search by CAS Number, Product Name, or Category...", // @en
  "categories.human_apis.title": "Human APIs", // @en
  "categories.human_apis.description": "Pharmaceutical active ingredients for human therapeutics with full regulatory documentation.", // @en
  "categories.intermediates.title": "Intermediates", // @en
  "categories.intermediates.description": "High-quality pharmaceutical intermediates and building blocks for drug synthesis.", // @en
  "categories.veterinary.title": "Veterinary APIs", // @en
  "categories.veterinary.description": "Specialized compounds for animal health and veterinary pharmaceutical applications.", // @en
  "categories.products_count": "+ Products", // @en
  "featured.title": "주요 제품",
  "featured.subtitle": "Explore our most popular pharmaceutical compounds trusted by global manufacturers.", // @en
  "featured.view_all": "전체 제품 보기",
  "features.title": "Why Choose Longshine Boi-Tech", // @en
  "features.subtitle": "Decades of pharmaceutical know-how plus current-generation process technology — delivering APIs and intermediates that hold up against any global standard.", // @en
  "features.iso.title": "ISO 9001:2015 Certified", // @en
  "features.iso.description": "Internationally recognized quality management system ensuring consistent excellence in all our processes and products.", // @en
  "features.global.title": "Global Supply Chain", // @en
  "features.global.description": "Reliable worldwide distribution network serving pharmaceutical companies across 50+ countries with timely delivery.", // @en
  "features.compliance.title": "Regulatory Compliance", // @en
  "features.compliance.description": "Full compliance with FDA, EMA, and other international regulatory standards for pharmaceutical manufacturing.", // @en
  "features.custom.title": "Custom Manufacturing", // @en
  "features.custom.description": "Flexible CMO/CDMO services for custom synthesis, scale-up production, and specialized pharmaceutical compounds.", // @en
  "features.team.title": "Expert Team", // @en
  "features.team.description": "Experienced R&D professionals and regulatory experts dedicated to delivering innovative pharmaceutical solutions.", // @en
  "features.facilities.title": "Advanced Facilities", // @en
  "features.facilities.description": "Modern manufacturing facilities with current-generation process equipment and validated quality control systems.", // @en
  "cta.title": "파트너십을 시작하시겠습니까?",
  "cta.subtitle": "Join hundreds of global pharmaceutical companies who trust Longshine Boi-Tech for their API and intermediate supply needs.", // @en
  "cta.quote_now": "지금 견적 요청",
  "cta.download_catalog": "카탈로그 다운로드",
  "product.cas": "CAS",
  "product.moq": "MOQ",
  "product.bulk_discount": "Bulk discounts available", // @en
  "product.details": "자세히",
  "product.sds": "MSDS",
  "product.add_rfq": "장바구니 추가",
  "product.download_started": "Download Started", // @en
  "product.sds_downloading": "Safety Data Sheet for {product} is downloading", // @en
  "product.download_error": "Download Error", // @en
  "product.sds_error": "Could not download SDS for {product}. Please contact support.", // @en
  "product.added_rfq": "Added to cart", // @en
  "product.added_cart": "{product} has been added to your cart", // @en
  "product.view_cart": "장바구니 보기",
  "about.hero.title": "About Longshine Boi-Tech", // @en
  "about.hero.description": "Since 2009, we have been at the forefront of pharmaceutical innovation, delivering premium APIs and intermediates that meet the highest global standards while building trusted partnerships with manufacturers worldwide.", // @en
  "about.hero.years": "15+ Years of Excellence", // @en
  "about.hero.global": "Global Reach", // @en
  "about.story.title": "Our Story", // @en
  "about.story.p1": "Longshine Boi-Tech was founded in 2009 with a vision to bridge the gap between innovative pharmaceutical research and reliable global supply. Starting as a small research facility in Pune, Maharashtra, we have grown into a leading manufacturer of pharmaceutical active ingredients.", // @en
  "about.story.p2": "Our commitment to quality and regulatory compliance has enabled us to build long-term partnerships with pharmaceutical companies across six continents. Every product we manufacture undergoes rigorous testing and quality assurance to ensure it meets international pharmaceutical standards.", // @en
  "about.story.p3": "Today, Longshine Boi-Tech is recognized as a trusted supplier of premium APIs, intermediates, and veterinary compounds, with ISO 9001:2015 certification and multiple regulatory approvals including FDA DMFs and European CEPs.", // @en
  "about.journey.title": "Our Journey", // @en
  "about.journey.subtitle": "Key milestones that shaped our growth", // @en
  "about.leadership.title": "Leadership Team", // @en
  "about.leadership.subtitle": "Experienced professionals driving our success", // @en
  "about.leadership.rajesh.name": "Dr. Rajesh Kumar", // @en
  "about.leadership.rajesh.position": "CEO & Founder", // @en
  "about.leadership.rajesh.background": "Former pharmaceutical research director with 20+ years experience in API development and regulatory affairs across India and global markets.", // @en
  "about.leadership.priya.name": "Dr. Priya Sharma", // @en
  "about.leadership.priya.position": "Chief Technology Officer", // @en
  "about.leadership.priya.background": "PhD in Pharmaceutical Chemistry from IIT Mumbai, expert in process optimization and quality assurance systems with international certifications.", // @en
  "about.leadership.amit.name": "Amit Patel", // @en
  "about.leadership.amit.position": "VP of Global Sales", // @en
  "about.leadership.amit.background": "International business development leader with extensive experience in pharmaceutical supply chains and strategic partnerships across APAC and European markets.", // @en
  "about.milestone.2009": "Company founded in Pune, Maharashtra, India", // @en
  "about.milestone.2012": "ISO 9001:2015 certification achieved", // @en
  "about.milestone.2015": "First international API exports", // @en
  "about.milestone.2018": "FDA DMF submissions approved", // @en
  "about.milestone.2020": "Expanded to veterinary APIs", // @en
  "about.milestone.2023": "Serving 50+ countries globally", // @en
  "about.values.title": "Our Values", // @en
  "about.values.subtitle": "The principles that guide everything we do", // @en
  "about.values.excellence.title": "Excellence", // @en
  "about.values.excellence.description": "We pursue the highest standards in everything we do, from product quality to customer service, ensuring consistent excellence in all our operations.", // @en
  "about.values.integrity.title": "Integrity", // @en
  "about.values.integrity.description": "Transparency, honesty, and ethical business practices form the foundation of our relationships with customers, suppliers, and regulatory bodies.", // @en
  "about.values.innovation.title": "Innovation", // @en
  "about.values.innovation.description": "Continuous improvement and ongoing process research are how we keep developing better products and tighter manufacturing routes.", // @en
  "about.cta.title": "Ready to Partner with Us?", // @en
  "about.cta.subtitle": "Discover how Longshine Boi-Tech can support your pharmaceutical manufacturing needs with our premium APIs and exceptional service.", // @en
  "about.cta.products": "View Our Products", // @en
  "about.cta.contact": "Contact Our Team", // @en
  "contact.hero.title": "문의하기",
  "contact.hero.description": "Ready to partner with us? Our global team of pharmaceutical experts is here to support your API and intermediate supply requirements with personalized service and technical expertise.", // @en
  "contact.hero.support": "24/7 Customer Support", // @en
  "contact.hero.presence": "Global Presence", // @en
  "contact.form.title": "메시지 보내기",
  "contact.form.additional": "Additional Information", // @en
  "contact.form.subtitle": "Fill out the form below and our team will get back to you within 24 hours.", // @en
  "contact.form.order_subtitle": "Provide any additional requirements or special instructions for your order.", // @en
  "contact.form.first_name": "이름",
  "contact.form.last_name": "성",
  "contact.form.email": "이메일",
  "contact.form.phone": "전화번호",
  "contact.form.company": "회사명",
  "contact.form.country": "국가",
  "contact.form.inquiry_type": "Inquiry Type", // @en
  "contact.form.message": "메시지",
  "contact.form.files": "Attach Files (Optional)", // @en
  "contact.form.upload_text": "Click to upload or drag and drop", // @en
  "contact.form.upload_formats": "Supported formats: PDF, DOC, XLS (Max 10MB)", // @en
  "contact.form.consent": "I agree to the processing of my personal data and consent to receive marketing communications from Longshine Boi-Tech. You can unsubscribe at any time.", // @en
  "contact.form.send": "메시지 전송",
  "contact.form.submit_additional": "Submit Additional Information", // @en
  "contact.form.placeholder.first_name": "Enter your first name", // @en
  "contact.form.placeholder.last_name": "Enter your last name", // @en
  "contact.form.placeholder.email": "Enter your email", // @en
  "contact.form.placeholder.phone": "Enter your phone number", // @en
  "contact.form.placeholder.company": "Enter your company name", // @en
  "contact.form.placeholder.country": "Select your country", // @en
  "contact.form.placeholder.message": "Please provide details about your inquiry, including specific products of interest, quantities, and any technical requirements...", // @en
  "contact.form.placeholder.message_order": "Please provide any special requirements, delivery instructions, or additional information for your order...", // @en
  "contact.quick.title": "Quick Contact", // @en
  "contact.quick.main_office": "Main Office", // @en
  "contact.quick.general": "General Inquiries", // @en
  "contact.quick.headquarters": "Headquarters", // @en
  "contact.response.title": "Response Times", // @en
  "contact.crypto.title": "Crypto Payment Support", // @en
  "contact.crypto.description": "Need help with your cryptocurrency payment? Our crypto payment specialists are available 24/7.", // @en
  "contact.crypto.support": "Get Crypto Support", // @en
  "contact.payment.complete_order": "Complete Your Order", // @en
  "contact.payment.review_items": "Review your cart items and choose your preferred payment method. We accept major cryptocurrencies for fast, secure transactions.", // @en
  "contact.payment.crypto": "Cryptocurrency", // @en
  "contact.payment.bank": "Bank Transfer", // @en
  "contact.payment.traditional": "Traditional Payment Methods", // @en
  "contact.payment.bank_desc": "For bank transfers and traditional payment methods, please contact our sales team for detailed payment instructions.", // @en
  "contact.payment.contact_sales": "Contact Sales for Payment Details", // @en
  "products.hero.human_apis": "Human APIs", // @en
  "products.hero.intermediates": "Pharmaceutical Intermediates", // @en
  "products.hero.veterinary": "Veterinary APIs", // @en
  "products.hero.catalog": "Product Catalog", // @en
  "products.hero.human_desc": "High-quality active pharmaceutical ingredients for human medicine, manufactured to international standards with comprehensive regulatory support.", // @en
  "products.hero.intermediates_desc": "Pharmaceutical intermediates and building blocks for drug synthesis — tight purity targets and a reliable supply track record.", // @en
  "products.hero.veterinary_desc": "Specialized active ingredients for veterinary applications, ensuring animal health and well-being with proven efficacy.", // @en
  "products.hero.catalog_desc": "Discover our comprehensive range of pharmaceutical active ingredients, intermediates, and veterinary compounds manufactured to international standards.", // @en
  "products.hero.available": "+ Products Available", // @en
  "products.search.placeholder": "Search by CAS Number, Product Name, or Keyword...", // @en
  "products.filter.by": "Filter by:", // @en
  "products.filter.category": "Category", // @en
  "products.filter.availability": "Availability", // @en
  "products.filter.advanced": "Advanced Filters", // @en
  "products.filter.export": "Export Catalog", // @en
  "products.showing": "Showing {count} products", // @en
  "products.results.all": "All Products", // @en
  "products.sort.relevance": "Relevance", // @en
  "products.sort.name": "Name A-Z", // @en
  "products.sort.category": "Category", // @en
  "products.sort.availability": "Availability", // @en
  "footer.company": "Longshine Boi-Tech Co., Ltd.",
  "footer.certified": "ISO 9001:2015 Certified Excellence", // @en
  "footer.description": "Leading pharmaceutical manufacturer delivering premium APIs, intermediates, and veterinary compounds to global markets with uncompromising quality.", // @en
  "footer.products": "Products", // @en
  "footer.company_links": "Company", // @en
  "footer.human_apis": "Human APIs", // @en
  "footer.intermediates": "Intermediates", // @en
  "footer.veterinary": "Veterinary APIs", // @en
  "footer.all_products": "All Products", // @en
  "footer.about": "About Us", // @en
  "footer.capabilities": "Capabilities", // @en
  "footer.quality": "Quality & Compliance", // @en
  "footer.contact": "Contact", // @en
  "footer.copyright": "© 2026 Longshine Boi-Tech Pvt. Ltd. 판권 소유.",
  "common.search": "검색",
  "common.categories.all": "All Categories", // @en
  "common.categories.human": "Human APIs", // @en
  "common.categories.intermediates": "Intermediates", // @en
  "common.categories.veterinary": "Veterinary APIs", // @en
  "common.availability.all": "All Availability", // @en
  "common.availability.in_stock": "In Stock", // @en
  "common.availability.on_demand": "On Demand", // @en
  "common.availability.custom": "Custom", // @en
  "common.loading": "로딩 중...",
  "common.error": "오류",
  "common.success": "성공",
};
